var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4567 15H26.4667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5406 16.42C31.4218 15.9454 31.1799 15.5106 30.8392 15.1594C30.4986 14.8082 30.0713 14.5532 29.6006 14.42C27.8806 14 21.0006 14 21.0006 14C21.0006 14 14.1206 14 12.4006 14.46C11.9298 14.5932 11.5025 14.8482 11.1619 15.1994C10.8213 15.5506 10.5794 15.9854 10.4606 16.46C10.1458 18.2056 9.99181 19.9763 10.0006 21.75C9.98935 23.537 10.1433 25.3213 10.4606 27.08C10.5915 27.5398 10.8389 27.9581 11.1787 28.2945C11.5186 28.6308 11.9394 28.8738 12.4006 29C14.1206 29.46 21.0006 29.46 21.0006 29.46C21.0006 29.46 27.8806 29.46 29.6006 29C30.0713 28.8668 30.4986 28.6118 30.8392 28.2606C31.1799 27.9094 31.4218 27.4746 31.5406 27C31.8529 25.2676 32.0069 23.5103 32.0006 21.75C32.0118 19.963 31.8578 18.1787 31.5406 16.42Z",
    fill: "#006CB8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25.54L24.75 22.27L19 19V25.54Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.cd1dd3d8bb2a40fd642dcafcd006de4f.svg";
export { ForwardRef as ReactComponent };